import { useState, useEffect } from "react";
import { isEmpty } from "lodash";

export const getDimensions = (ele) => {
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height + ele.style.marginTop;

  return {
    height,
    offsetTop,
    offsetBottom,
  };
};

export const scrollTo = (ele) => {
  ele.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
/*
 * useScrollView takes two arguments
 *
 * contentRefs: a ref to Map object of in the form [id]: { ele:, content }
 * headerRef: a ref to the sticky header to account for the scroll offset
 *
 * Atm it requires the scrollable content to be within :
 * <div id="PageContentScrollContainer">
 */
export const useScrollViewOn =
  (scrollContainterId) =>
  ({ contentRefs, headerRef }) => {
    const [visibleSection, setVisibleSection] = useState();
    useEffect(() => {
      const handleScroll = () => {
        const { height: headerHeight } =
          headerRef.current.getBoundingClientRect();

        const scrollPosition =
          document.getElementById(scrollContainterId).scrollTop + headerHeight;

        const contents = Array.from(contentRefs.current.values());
        const selected = contents.find(({ ele }, index) => {
          const nextContent = contents[index + 1];
          if (ele) {
            const { offsetBottom, offsetTop } = getDimensions(ele);
            if (nextContent) {
              const result =
                scrollPosition >= offsetTop &&
                scrollPosition < nextContent.ele.offsetTop;
              return result;
            } else {
              return (
                scrollPosition > offsetTop && scrollPosition < offsetBottom
              );
            }
          }
        });

        if (selected && selected.content.uuid !== visibleSection) {
          setVisibleSection(selected.content.uuid);
        } else if (!selected && visibleSection) {
          setVisibleSection(undefined);
        }
      };

      handleScroll();

      document
        .getElementById(scrollContainterId)
        .addEventListener("scroll", handleScroll);
      return () => {
        document
          .getElementById(scrollContainterId)
          ?.removeEventListener("scroll", handleScroll);
      };
    }, [visibleSection]);
    return visibleSection;
  };

export const useDelayedScrollToElement = ({ hash }) => {
  useEffect(() => {
    const destination = document.getElementById(hash.replace("#", ""));
    if (destination) {
      scrollTo(destination);
    }
  }, [hash]);
};

const useScrollView = useScrollViewOn("PageContentScrollContainer");
export default useScrollView;
